(function () {
  if (customElements.get('product-info-tabs')) {
    return;
  }

  class ProductInfoTabs extends HTMLElement {
    connectedCallback() {
      if (this._initialized) {
        return;
      }

      this._initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (!this.tabs.length || !this.panels.length) {
        return;
      }

      this.tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          this.activateTab(index);
        }.bind(this));

        tab.addEventListener('keydown', function (event) {
          this.handleKeydown(event, index);
        }.bind(this));
      }.bind(this));
    }

    activateTab(index) {
      if (index < 0 || index >= this.tabs.length) {
        return;
      }

      this.tabs.forEach(function (tab, tabIndex) {
        var isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach(function (panel, panelIndex) {
        var isActive = panelIndex === index;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      var activeTab = this.tabs[index];
      if (activeTab && typeof activeTab.scrollIntoView === 'function') {
        activeTab.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }

    handleKeydown(event, index) {
      var nextIndex = index;
      var lastIndex = this.tabs.length - 1;

      switch (event.key) {
        case 'ArrowRight':
          nextIndex = index === lastIndex ? 0 : index + 1;
          break;
        case 'ArrowLeft':
          nextIndex = index === 0 ? lastIndex : index - 1;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = lastIndex;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.activateTab(nextIndex);
      this.tabs[nextIndex].focus();
    }

    disconnectedCallback() {
      this._initialized = false;
    }
  }

  customElements.define('product-info-tabs', ProductInfoTabs);
})();
